import Id from './Id';
import Type from './Type';
import Status from './Status';
import From from './From';
import To from './To';
import SourceUser from './SourceUser';
import TargetUser from './TargetUser';
import SourceStorage from './SourceStorage';
import TargetStorage from './TargetStorage';
import CreatorUser from './CreatorUser';
import Comment from './Comment';
import Created from './Created';
import Updated from './Updated';
import ReplacementDate from './ReplacementDate';

export const labels = {
  Id: 'Id',
  Type: 'Típus',
  Status: 'Státusz',
  From: 'Helyettesítés kezdete',
  To: 'Helyettesítés vége',
  SourceUser: 'Forrás képviselő',
  TargetUser: 'Cél képviselő',
  SourceStorage: 'Forrás raktár',
  TargetStorage: 'Cél raktár',
  CreatorUser: 'Létrehozta',
  Comment: 'Megjegyzés',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  ReplacementDate: 'Áthelyezés időpontja',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Type',
}, {
  value: 'Status',
}, {
  value: 'From',
}, {
  value: 'To',
}, {
  value: 'SourceUser',
}, {
  value: 'TargetUser',
}, {
  value: 'SourceStorage',
}, {
  value: 'TargetStorage',
}, {
  value: 'CreatorUser',
}, {
  value: 'Comment',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Type',
}, {
  value: 'Status',
}, {
  value: 'SourceUser',
}, {
  value: 'TargetUser',
}, {
  value: 'From',
}, {
  value: 'To',
}, {
  value: 'CreatorUser',
}, {
  value: 'Comment',
}];

export const defaultSort = {
  prop: 'id',
  order: 'descending'
};

export default {
  Id,
  Type,
  Status,
  From,
  To,
  SourceUser,
  TargetUser,
  SourceStorage,
  TargetStorage,
  CreatorUser,
  Comment,
  Created,
  Updated,
  ReplacementDate,
};
